module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11y2JE0/tc-custom/9780830899432.jpg?1696024355891",
      "alt": "This image is the cover for the book A Little Handbook for Preachers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Little Handbook for Preachers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("No function of the pastor is as visible and stress inducing as preaching. Being a good preacher requires learning the mental, emotional, spiritual and physical skills needed to effectively share God's word with a congregation. It demands a commitment to the craft of preaching. But few pastors feel adequately prepared for this high-stakes responsibility when they begin their ministries. Mary Hulst knows what it takes to preach well. Forged by her experiences as a pastor, preaching professor and college chaplain, she recognizes the challenges of the pulpit. In this uniquely practical book, Hulst provides foundational concepts and tips that all pastors can use, whether they are ministry newcomers or seasoned professionals. Preaching can bring both you and your congregation great joy and satisfaction, week after week. And"), _c('em', [_vm._v("A Little Handbook for Preachers")]), _vm._v(" can help you deliver a better sermon by Sunday.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary S. Hulst, Mark Labberton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Mary S. Hulst (PhD, University of Illinois) is the college chaplain and a member of the faculty at Calvin College where she preaches weekly at campus services. She previously served as a professor of preaching at Calvin Theological Seminary and as senior pastor of Eastern Avenue Christian Reformed Church. She lives in Grand Rapids, Michigan, with her husband Andrew Kromminga.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0